<template>
    <div class="login-page">
        <CameraCapture :res_out="getCamRes"></CameraCapture>
        <QrCode :qr_func="getSerialNumb" :manual="true"></QrCode>
    <nav class="navbar navbar-absolute navbar-transparent">
      <div class="container">
        <div class="navbar-wrapper">
          <a class="navbar-brand">Modern-Expo Go Go</a>

          <div class="navbar-container content container-fluid float-xs-right">
            <!--<div class="navbar-toggleable-sm" id="navigation">
                <ul class="nav navbar-nav">
                  <li class="dropdown dropdown-language nav-item">
                    <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                      <i class="nc-icon nc-globe-2"></i>
                    </a>
                    
                    <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                      <a class="dropdown-item" @click="changeLanguage('en')"><i class="flag-icon"></i> EN</a>
                      <a class="dropdown-item" @click="changeLanguage('ua')"><i class="flag-icon"></i> UA</a>
                      <a class="dropdown-item" @click="changeLanguage('ru')"><i class="flag-icon"></i> RU</a>
                    </div>
                  </li>
              </ul>
            </div>-->
          </div>

        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    <div class="wrapper wrapper-full-page ">
      <div class="full-page section-image" filter-color="black">
        <div
          class="full-page-background"
          :style="{ backgroundImage: 'url(' + require('./../assets/img/bg/modern.jpg') + ')'}" />
        <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
        <div class="content">
          <div class="container-fluid">
            <div class="col-lg-6 ml-auto mr-auto">
              <form class="form" method="" action="">
                <div class="card card-login">
                  <div class="card-header ">
                    <div class="card-header ">
                      <h3 class="header text-center" style="margin-bottom: 0">Перевірка якості</h3>
                    </div>
                  </div>
                  <div class="card-body">

                    <div class="col-md-8 offset-md-2">

                      <div class="input-group mb-0">
                        <input type="text" class="form-control"  v-model="serial">
                        <div class="input-group-append">
                          <span class="input-group-text btn-warning hand" style="background-color: #fbc658; color: #FFFFFF;font-weight: 600; font-size: 0.8571em;" data-toggle="modal" data-target="#modalQR" @click="$store.state.active_qr = true;">
                            &nbsp;&nbsp;&nbsp;QR code&nbsp;
                          </span>
                        </div>
                      </div>

                    
                    </div>

                    <div style="display: flex; justify-content: center;">
                        <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                            <i style="color: #FFFFFF" class="nc-icon nc-camera-compact"></i> Камера 
                        </button>
                        <input type="file" name="file" id="file" class="inputfile" multiple="multiple" @change="onUploadImg"/>
                        <label id="file_loader" for="file">
                          <a class="btn btn-warning" style="font-size: 1em; color: white"><i class="nc-icon nc-image"></i> Вибрати</a>
                        </label>
                        <!--
                          <button type="button" class="btn btn-warning" @click="images = []; images2 = []" v-if="images.length > 0">
                            <i class="nc-icon nc-box"></i> delete images
                          </button>
                        -->
                    </div>
                    <div class="col-md-12">
                      <div style="display: flex; justify-content: center;">
                        <div style="min-width: 5%;max-width: 15%; position: relative; margin-right: 1%; margin-top: 1%; cursor: pointer;" v-for="(image,index) in images" :key="index" @click="deleteItem(index)">
                          <img v-bind:src="image.data" style="width:100%" />
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="card-footer ">
                    <a class="btn btn-warning btn-block mb-3" @click="sendFiles" style="color: white">
                        <h4 style="margin:0"><i class="nc-icon nc-cloud-upload-94"></i> Відправити</h4>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
        
        <footer class="footer footer-black  footer-white ">
          <div class="container-fluid">
            <div class="row">
              <nav class="footer-nav">
                <ul>
                  <li>
                    <a href="https://www.modern-expo.com/" target="_blank">Modern-Expo site</a>
                  </li>
                </ul>
              </nav>
              <div class="credits ml-auto">
              <span class="copyright">
                © made with <i class="fa fa-heart heart"></i> by Modern-Expo IT TEAM
              </span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div v-show="$store.state.isLoading">
      <div class="loader-overlay" id="point-loader" style="position: fixed !important;">
        <div
          style="height:100%;
                  display:flex;
                  justify-content: center;
                  align-items:center;">
          <atom-spinner :animation-duration="1000" :size="160" :color="'#ff1d5e'"/>
        </div>
      </div>
    </div>
    <notifications group="error" classes="alert alert-danger"/>
    <notifications group="info" classes="alert alert-info"/>
    <notifications group="success" classes="alert alert-success"/>
  </div>

</template>

<script>
    import CameraCapture from '../components/Camera.vue';
    import {AtomSpinner} from "epic-spinners";
    import QrCode from "../components/QrCode.vue"

    export default {
        name: "Problem",
        data() {
            return{
                errors: [],
                serial: null,
                images: [],
                images2: [],
                index: 0,
            }
        },
        methods:{
            onUploadImg(e){
              if(!this.isValid(this.serial)){
                this.$notify({ group: 'error', title: 'Warning', text: 'Введіть серійний номер' }); 
              } else {
                let tt = null;
                if (e.target.files.length > 0){
                    for (let i = 0; i < e.target.files.length; i++) {
                        const element = e.target.files[i];
                        const reader = new FileReader();
                        reader.readAsDataURL(element);
                        reader.onload = e => {
                            tt = (e.target.result).split(',');
                            this.images.push({name: this.serial + '_' + (Math.random(100)) + '.png', data: e.target.result/*tt[1]*/});
                            this.images2.push({name: this.serial + '_' + (Math.random(100)) + '.png', data: tt[1]});
                        };                        
                    }
                }
              }
            },
            sendFiles(e) {  
              e.preventDefault();
              
              let errors = []; 
              let ssParent = this;
              let dataRequest = { images: null,images2: null,serial: null};
              
              if(this.images.length == 0){ errors.push('Прикріпіть фото'); }
              if(!this.isValid(this.serial)){ errors.push('Відсутній серійний номер'); }

              if(errors.length == 0){
                this.serial = 'ме-' + this.serial.split('-')[1];

                let img_tmp = [[]],img_tmp2 = [[]], j = 0;

                for (let i = 0; i < this.images2.length; i++) {
                  if(img_tmp[j].length > 4){
                    j = j + 1;
                    img_tmp[j] = [];
                    img_tmp2[j] = [];
                  }
                  img_tmp[j].push(this.images[i]);
                  img_tmp2[j].push(this.images2[i]);
                }

                let i = 0;
                while(i < img_tmp2.length){
                  setTimeout(function(i) {
                    console.log(i);
                    dataRequest.images = img_tmp[i];
                    dataRequest.images2 = img_tmp2[i],
                    dataRequest.serial = ssParent.serial;

                    console.log(dataRequest);
                    /*ssParent.makeQuery("/draw/addimageserialnumber",{dataRequest : dataRequest})
                    .then(res => {
                        if(res != null){
                            ssParent.$notify({ group: 'success', title: ser, text: 'Пакет файлів відправлено'});

                            if(ind == (arr2.length - 1)){
                              ssParent.serial = null;
                              ssParent.images = [];
                              ssParent.images2 = [];
                            }
                        }
                    });*/
                  }, 2000);//iis delay for queries
                  
                  i++;
                }

              } else if(errors.length != 0){
                for (let i = 0; i < errors.length; i++) {
                  this.$notify({ group: 'error', title: 'Warning', text: errors[i] });
                }
              } 

            },
            getCamRes(dataCam){               
              if(!this.isValid(this.serial)){
                this.$notify({ group: 'error', title: 'Warning', text: 'Введіть серійний номер' }); 
              } else {
                if (this.isValid(dataCam)){
                    this.images.push({name: this.serial + '_'  + (Math.random(100)) + '.png', data: dataCam/*.split(',')[1]*/});
                    this.images2.push({name: this.serial + '_' + (Math.random(100)) + '.png', data: dataCam.split(',')[1]});
                }
              }
            },
            deleteItem(index){
              //remove item
              this.images.splice(index, 1);
              this.images2.splice(index, 1);
            },
            getSerialNumb(serial){
              if ( this.isValid(serial) ){
                this.serial = serial;
                this.serial = 'ме-' + this.serial.split('-')[1];
              } else {
                this.$notify({ group: 'error', title: 'Warning', text: 'Serial number can not be empty!'});
              }
            }
        },
        computed: {},
        components: {
            CameraCapture,
            AtomSpinner,
            QrCode,
        },
        created(){},
        mounted(){},
        created(){
          //this.$router.push({ name: 'login'});
        },
    }
</script>

<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 1%;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
.hand{
  cursor: pointer;
}
</style> 


// WEBPACK FOOTER //
// src/pages/ProductDTO.vue